import styled from 'styled-components'

export const Overlay = styled.div`
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(40,44,52);
  background: linear-gradient(0deg, rgba(40,44,52,1) 15%, rgba(0,0,1,1) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  animation: fadeIn 0.3s ease-out forwards;

  @media (max-width: 550px) {
        /* Phones */
        overflow-y: scroll;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        overflow-y: scroll;
      }
     

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const Modal = styled.div`
  margin-top: 2em;
  padding: 2rem;
  border-radius: 10px;
  width: 80%;
  display: flex;
  opacity: 0;
  transform: translateY(20px);
  animation: slideUp 0.4s ease-out 0.2s forwards;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 550px) {
    /* Phones */
    flex-direction: column;
    margin-top: 2em;
    align-items: center;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    flex-direction: column;
    margin-top: 2em;
    align-items: center;
  }
`;

export const LeftSection = styled.div`
  width: 40%;
  padding: 2rem;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 10px 0 0 10px;

  @media (max-width: 550px) {
    /* Phones */
    width: 100%;
    padding: 0rem;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 100%;
    padding: 0rem;
  }

  hr{
    border: none;
    height: 1px;
    width: 35%;
    background-color: white;
    margin: 10px 0;

    @media (max-width: 550px) {
    /* Phones */
    width: 90%;
    padding: 0rem;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 90%;
    padding: 0rem;
  }
  }


  h1{
    font-size: 4em;

    @media (max-width: 550px) {
    /* Phones */
    font-size: 3em;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 3em;
  }
  }

  p{
    color: #7D7C7C;
  }
`;

export const Label = styled.p`
width: 90%;
  color: white;
  font-size: 1.2em;
  text-align: left;
  margin-top: 1rem;
  font-weight: bold;
`;

export const ContentContainer = styled.div`

  width: 50%;
  padding: 2rem;

  background: linear-gradient(180deg, rgba(40, 44, 52, 0.8) 0%, rgba(118, 130, 154, 0.05) 100%);
  border-radius: 25px;

  @media (max-width: 550px) {
    /* Phones */
    width: 100%;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 100%;
  }
`

export const RightSection = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
  width: 60%;

  @media (max-width: 550px) {
    /* Phones */
    width: 90%;
    margin-top: 1em;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 90%;
    margin-top: 1em;
  }
`;

export const Title = styled.h2`
  color: #fff;
  font-size: 2.1em;
  margin-bottom: 1rem;
  text-align: center;
`;

export const Input = styled.input`
  width: 90%;
  padding: 10px 10px 10px 20px;
  margin: 10px 0;
  border-radius: 50px;
  border: none;
  background: #333;
  color: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:focus {
    background: #444;
    box-shadow: 0 0 0 2px rgba(234, 11, 42, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1);
    outline: none;
    transform: translateY(-1px);
  }
`;

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;

  button {
    width: 80%;
    background: rgba(234, 11, 42, 1);
    color: white;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    margin-top: 1rem;
    margin-bottom: 1em;
    padding: 8px 40px;
    text-align: center;
    transition: all 0.3s ease;
    transform: scale(1);

    &:hover {
      background: rgb(210, 11, 37);
      transform: scale(1.02);
    }

    &:active {
      transform: scale(0.98);
    }
  }
`;

export const SmallText = styled.p`
text-transform: uppercase;
text-align: center;
  color: gray;
  font-size: 0.8rem;
  margin-top: 10px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    text-decoration: underline;
    color: #EA0B2A;
  }
`;

export const CreateButton = styled.div`
  display: flex;
  margin-top: 10px;

  a{
    color: white;
    text-decoration: none;
  }

  button {
    width: 70%;
    background: rgba(234, 11, 42, 1);
    color: white;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    margin-top: 1rem;
    margin-bottom: 1em;
    padding: 8px 40px;
    text-align: center;
    transition: all 0.3s ease;
    transform: scale(1);

    @media (max-width: 550px) {
      /* Phones */
      width: 70%;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      width: 70%;
    }

    &:hover {
      background: rgb(210, 11, 37);
      transform: scale(1.02);
    }

    &:active {
      transform: scale(0.98);
    }
  }
`
